import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DomainName, LIMIT_USER, STATUS } from "../../../Constants";
import axios from "axios";
import { toast } from "react-toastify";


// For Edit User
const editUserEndpoint = (args )=> `${DomainName}/user/specific?id=${args.id}` ;

export const editUserAPI = createAsyncThunk('admin/editUser' , async ( args ,  thunkAPI)=>{
    const {rejectWithValue} = thunkAPI ; 
    try{
        const response = await axios.put(editUserEndpoint(args) , {
            username : args.username , 
            email : args.email ,
            password: args.password , 
            confirmPassword : args.confirmPassword , 
        } , {
            headers : {
                token : args.token
            }
        })
        
        return response.data

    }catch(error){
        return rejectWithValue(error) ;
    }
})


// For Remove User
const removeUserEndpoint = (args)=>`${DomainName}/user/specific?id=${args.id}` ; 

export const removeUserAPI = createAsyncThunk('admin/removeUser' , async (args, thunkAPI)=>{
    const {rejectWithValue}  = thunkAPI
    try{
        await axios.delete(removeUserEndpoint(args) , {
            headers : {
                token : args.token
            }
        })
        return {id :args.id , name: args.name}
    }catch(error){
        return rejectWithValue(error) ;
    }
})

// For Search for users
const searchUserEndpoint = (args)=> `${DomainName}/user/search?search=${args.searchValue}&limit=${LIMIT_USER}&page=${args.page? args.page :1}` ;

export const searchUserAPI = createAsyncThunk('admin/searchUser' , async (args , thunkAPI)=>{

    const {rejectWithValue } = thunkAPI

    try{
        const response = await axios.get(searchUserEndpoint(args) , {
            headers : {
                token : args.token
            }
            
        })
        return response.data
    }catch(error){
        return rejectWithValue(error) ;
    }
    

})

// For Set Epxiration API
const setExpirationEndPoint = (args)=>`${DomainName}/user/expire` ; 

export const setExpirationAPI = createAsyncThunk('admin/setExpir' , async (args , thunkAPI)=>{
    const {rejectWithValue , dispatch} = thunkAPI ;  
    try{
        const response = await axios.post(setExpirationEndPoint(args) , 
            {
                expiredAt:args.expiredAt,
                userId:args.userId
            }
         , {
            headers : {
                token : args.token
            }
        })
        dispatch(getAllUsersAPI({token : args.token , page : args.page}))

        return response.data?.user
    }catch(error){
        return rejectWithValue(error) ; 
    }
})


// For Add Point
const UpdatePointEndpoint = (args)=> `${DomainName}/page/updatePoints?userId=${args.userId}` ; 

export const UpdatePointAPI = createAsyncThunk("admin/updatepoint" , async (args , thunkAPI)=>{
    const {rejectWithValue , dispatch} = thunkAPI ; 
    try{
         await axios.patch(UpdatePointEndpoint(args) , {
            userId:args.userId,
            points:parseInt(args.points)
        } , {
            headers : {
                token : args.token
            }
        })

        dispatch(getAllUsersAPI({token : args.token , page : args.page}))
        
    }catch(error){
        return rejectWithValue(error)
    }
}) 

// For Add Point
const addPointEndpoint = (args)=> `${DomainName}/page/addPoints?userId=${args.userId}` ; 

export const AddPointAPI = createAsyncThunk("admin/addpoint" , async (args , thunkAPI)=>{
    const {rejectWithValue , dispatch} = thunkAPI ; 
    try{
         await axios.post(addPointEndpoint(args) , {
            userId:args.userId,
            points:parseInt(args.points)
        } , {
            headers : {
                token : args.token
            }
        })

        dispatch(getAllUsersAPI({token : args.token , page : args.page}))
        
    }catch(error){
        return rejectWithValue(error)
    }
}) 


// For Get User By Id
const getUserByIdEndpoint = (args) => `${DomainName}/user/specific?id=${args.id}`;

export const getUserByIdAPI = createAsyncThunk('admin/getuserbyid', async (args, thunkAPI) => {
    const {rejectWithValue} = thunkAPI;
    try{
        const response = await axios.get(getUserByIdEndpoint(args), {
            headers: {
                token: args.token
            }
        })
        return response?.data;
    }catch(error){
        return rejectWithValue(error) ; 
    }
})

// For Add User 
const AddUserEndPoint = ()=> `${DomainName}/user` ; 

export const AddUserAPI = createAsyncThunk('admin/addUser' , async (args ,  thunkAPI)=>{
    const {rejectWithValue , dispatch} = thunkAPI ; 
    try{
        const response = await axios.post(AddUserEndPoint(args),{
                username:args.username,
                email:args.email,
                password:args.password,
                confirmPassword :args.confirmPassword,
                points:args.points , 
                mobileNumber : args.mobileNumber
        } , {
            headers : {
                token : args.token
            }
        } )

        dispatch(getAllUsersAPI({token : args.token , page : args.page}))
    }
    catch(error){
        return rejectWithValue(error)  ;
    }
})

// For Un Block User
const unBlockEndpoint = (args)=>`${DomainName}/user/unblock?id=${args.id}` ; 

export const unBlockAPI = createAsyncThunk('admin/unblock' , async (args, thunkAPI)=>{
    const {rejectWithValue } = thunkAPI ; 
    try{
            await axios.patch(unBlockEndpoint(args) , {} , {
            headers : {
                token : args.token
            }
        })
        return args.id
        // dispatch(getAllUsersAPI({token : args.token}))
    }catch(error){
        return rejectWithValue(error) ; 
    }
})

// For Block User
const blockEndpoint = (args)=>`${DomainName}/user/block?id=${args.id}` ; 

export const blockAPI = createAsyncThunk('admin/block' , async (args, thunkAPI)=>{
    const {rejectWithValue } = thunkAPI ; 
    try{
            await axios.patch(blockEndpoint(args) , {} , {
            headers : {
                token : args.token
            }
        })
        return args.id
    }catch(error){
        return rejectWithValue(error) ; 
    }
})

// For Get All Users 
const getAllUsersEndpoint = (args)=>`${DomainName}/user?limit=${LIMIT_USER}&page=${args.page}` ; 
 
export const getAllUsersAPI = createAsyncThunk('admin/getusers' , async (args, thunkAPI)=>{
    const {rejectWithValue} = thunkAPI
    try{
        const response = await axios.get(getAllUsersEndpoint(args) , {
            headers : {
                token : args.token
            }
        })
        return response.data
    }catch(error){
        return rejectWithValue(error) ; 
    }
    ;
})


// For Default State 
const initialState = {  
    allUsers: [],
    userProfile: null, 
    statusAllUsers: STATUS.IDLE,
    totalPages: 1 , 
    removeStatus : STATUS.IDLE

}

const AdminSlice = createSlice({
    name : "admin" , 
    initialState , 
    reducers : {

    } , 
    extraReducers : (builder)=>{
        builder
        // For Get All Users 
        .addCase(getAllUsersAPI.fulfilled , (state , action)=>{
            state.allUsers = action.payload.users ; 
            state.statusAllUsers = STATUS.SUCCESS ; 
            state.totalPages = action.payload.totalPages 
        })
        .addCase(getAllUsersAPI.pending , (state , action)=>{
            state.statusAllUsers = STATUS.LOADDING ;
        })
        .addCase(getAllUsersAPI.rejected , (state , action)=>{
            state.statusAllUsers = STATUS.ERROR ; 
        })

        // For Add User
        .addCase(AddUserAPI.fulfilled , (state , action)=>{
            toast.success("User Added Successfully")
        })
        .addCase(AddUserAPI.rejected , (state , action)=>{
            toast.error("Something Error Pleas Try Again")
        })

        // For Block 
        .addCase(blockAPI.fulfilled , (state ,action)=>{
            const currentIndex =  state.allUsers.findIndex((item)=>item._id === action.payload) ; 
            console.log(`The Current Index ${currentIndex}`)
            state.allUsers[currentIndex].isBlocked = true ; 
        })
        // For UnBlock
        .addCase(unBlockAPI.fulfilled , (state ,action)=>{
            const currentIndex =  state.allUsers.findIndex((item)=>item._id === action.payload) ; 
            console.log(`The Current Index ${currentIndex}`)
            state.allUsers[currentIndex].isBlocked = false ; 
        })

         // Get User by ID
        .addCase(getUserByIdAPI.fulfilled, (state, action) => {
            state.userProfile = action.payload; 
        })
        .addCase(getUserByIdAPI.pending, (state) => {
            state.userProfile = null;
        })
        .addCase(getUserByIdAPI.rejected, (state , action) => {
            state.userProfile = null;
            if(action.payload.response?.status === 401){
                toast.error('Session has expired please login again!');
            }
        })

        // For Add Point
        .addCase(AddPointAPI.fulfilled , ()=>{
            toast.success("Point Added Successfully") ;
        })
        .addCase(AddPointAPI.rejected , ()=>{
            toast.error("Something error please Try Again ") ;
        })

        // For update Point 
        .addCase(UpdatePointAPI.fulfilled , ()=>{
            toast.success("Point Updated Successfully")
        })
        .addCase(UpdatePointAPI.rejected , ()=>{
            toast.error("Something error please Try Again ")
        })

        // For Set Expiration
        .addCase(setExpirationAPI.fulfilled , ()=>{
            toast.success("Set Expiration Date Successfully")
        })
        .addCase(setExpirationAPI.rejected , ()=>{
            toast.error("Something error please try again")
        })

        // For Search User
        .addCase(searchUserAPI.fulfilled , (state , action)=>{
            state.allUsers = action.payload.users ; 
            state.totalPages = action.payload.totalPages ; 
            state.statusAllUsers = STATUS.SUCCESS ; 
        })
        .addCase(searchUserAPI.pending , (state , action)=>{
            state.statusAllUsers = STATUS.LOADDING
        })
        .addCase(searchUserAPI.rejected , (state , action)=>{
            state.statusAllUsers = STATUS.ERROR ; 
            if(action.payload.status === 404) {
                state.allUsers = [] ; 
                state.totalPages = 0 ;
                
            }
        })

        // For Remove User
        .addCase(removeUserAPI.fulfilled , (state , action)=>{
            state.allUsers = state.allUsers.filter((item)=>{
                return item._id !== action.payload.id
            })
            toast.success(`User ${action.payload.name} removed successsfully`)
            state.removeStatus = STATUS.SUCCESS
        })
        .addCase(removeUserAPI.pending , (state )=>{
            state.removeStatus = STATUS.LOADDING
        })
        .addCase(removeUserAPI.rejected, (state)=>{
            toast.error("Something error please try again") ; 
            state.removeStatus = STATUS.ERROR ; 
        })

        // For Edit User 
        .addCase(editUserAPI.fulfilled , (state , action)=>{
            const userIndex = state.allUsers.findIndex((item)=>item._id === action.payload.user._id);
            if(userIndex >= 0){
                state.allUsers[userIndex] = action.payload.user ; 
                toast.success(`User ${action.payload.user.username} updated successfully`) ;
            }
        })
        .addCase(editUserAPI.rejected , ()=>{
            toast.error("Something error") ;
        })

    }
}) ;


export default AdminSlice.reducer ; 

export const getUsers = state => state.AdminSlice


export const getRemoveStatus = state => state.AdminSlice.removeStatus ; 